import { Form } from 'antd';
import LADClaimFinancialsForm from '../../Edit/Financials/LADClaimFinancialsForm';

const CreateLADFinancials = ({ claimsFinancialsForm, claimsDetailsForm, items }) => {
  const detailsData = Form.useWatch(null, claimsDetailsForm);
  return (
    <Form form={claimsFinancialsForm} name="claimsFinancialsForm">
      <LADClaimFinancialsForm form={claimsFinancialsForm} editMode items={items} detailsData={detailsData} />
    </Form>
  );
};

export default CreateLADFinancials;
